import { c as _c } from "react/compiler-runtime";
import { CheckCircleIcon, CloseCircleIcon, InfoIcon } from '@systemeio/ui/icons';
import { NotificationItemView } from 'modules/notifications/components/notification-item-view';
import { ruleIconSizeClassName } from 'modules/notifications/constants/notification-icons';
import { SharingFailReasonEnum } from 'modules/share/enum/sharing-fail-reason-enum';
import { SharingStatusEnum } from 'modules/share/enum/sharing-status-enum';
import { useCancelSharing } from 'modules/share/hooks/use-cancel-sharing';
import { useSharingStatusPolling } from 'modules/share/hooks/use-sharing-status-polling';
import { NotificationSharingItemInterface } from 'modules/share/types/sharing-notification-interface';
import useUser from 'shared/hooks/use-user';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { dateTimeFormat } from 'shared/utils/date-time-format';
import { getWorkflowEditorUrl } from 'shared/utils/get-workflow-editor-url';
import { twMerge } from 'tailwind-merge';
export interface SharingNotificationProps {
  notification: NotificationSharingItemInterface;
}
const SharingNotificationItem = t0 => {
  const $ = _c(31);
  const {
    notification: notificationItem
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const {
    cancelSharing,
    isCancelling
  } = useCancelSharing();
  const t1 = notificationItem.data.status === SharingStatusEnum.Running;
  let t2;
  if ($[0] !== notificationItem.data.sharingId || $[1] !== t1) {
    t2 = {
      sharingId: notificationItem.data.sharingId,
      allowFetch: t1
    };
    $[0] = notificationItem.data.sharingId;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    sharingStatus,
    mutate
  } = useSharingStatusPolling(t2);
  let T0;
  let handleCancel;
  let handleNotificationClick;
  let notification;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[3] !== cancelSharing || $[4] !== mutate || $[5] !== notificationItem || $[6] !== sharingStatus || $[7] !== t || $[8] !== user) {
    notification = {
      ...notificationItem,
      data: {
        ...notificationItem.data,
        ...(sharingStatus ?? {})
      }
    };
    const sharedResourceId = notification.data.sharedResourceId;
    handleNotificationClick = notification.data.status === SharingStatusEnum.Success && sharedResourceId ? () => {
      window.open(getWorkflowEditorUrl(sharedResourceId), "_blank");
    } : undefined;
    handleCancel = async () => {
      await cancelSharing(notification.data.sharingId);
      await mutate(_temp, false);
    };
    const getIcon = () => {
      switch (notification.data.status) {
        case SharingStatusEnum.Running:
          {
            return <InfoIcon className={twMerge(ruleIconSizeClassName, "fill-yellow")} />;
          }
        case SharingStatusEnum.Failed:
          {
            if (notification.data.failReason === SharingFailReasonEnum.CancelledByUser) {
              return <CloseCircleIcon className={ruleIconSizeClassName} />;
            }
            return <CloseCircleIcon className={twMerge(ruleIconSizeClassName, "fill-red")} />;
          }
        case SharingStatusEnum.Success:
          {
            return <CheckCircleIcon className={twMerge(ruleIconSizeClassName, "fill-green")} />;
          }
        default:
          {
            return <InfoIcon className={twMerge(ruleIconSizeClassName, "fill-yellow")} />;
          }
      }
    };
    const getMessage = () => {
      switch (notification.data.status) {
        case SharingStatusEnum.Running:
          {
            return t("dashboard.notifications.workflow_sharing_in_progress");
          }
        case SharingStatusEnum.Failed:
          {
            switch (notification.data.failReason) {
              case SharingFailReasonEnum.CancelledByUser:
                {
                  return t("dashboard.notifications.workflow_sharing_cancelled");
                }
              case SharingFailReasonEnum.FailedToShare:
                {
                  return t("dashboard.notifications.workflow_sharing_failed_to_share");
                }
              case SharingFailReasonEnum.ProcessingTimeExceeded:
                {
                  return t("dashboard.notifications.workflow_sharing_processing_time_exceeded");
                }
              case SharingFailReasonEnum.ResourceRemoved:
                {
                  return t("dashboard.notifications.workflow_sharing_resource_removed");
                }
              default:
                {
                  return t("dashboard.notifications.workflow_sharing_failed");
                }
            }
          }
        case SharingStatusEnum.Success:
          {
            return t("dashboard.notifications.workflow_sharing_completed");
          }
      }
    };
    const getDescription = () => {
      switch (notification.data.status) {
        case SharingStatusEnum.Running:
          {
            return notification.data.progressPercent !== undefined && <div className="flex items-center gap-3"><div className="bg-background-tertiary relative h-1 w-full max-w-[342px] rounded-full"><div className="bg-brand-primary absolute left-0 top-0 h-full rounded-full transition-[width] duration-300 ease-in-out" style={{
                  width: `${notification.data.progressPercent}%`
                }} /></div><div className="text-text-primary text-xs font-medium">{notification.data.progressPercent}%</div></div>;
          }
        case SharingStatusEnum.Failed:
        case SharingStatusEnum.Success:
          {
            return user && <div className="group-hover:text-text-primary transition">{dateTimeFormat(notification.data.updatedAt, {
                timeFormat: user.timeFormat,
                dateFormat: user.dateFormat,
                timeZone: user.timezone
              })}</div>;
          }
        default:
          {
            return;
          }
      }
    };
    T0 = NotificationItemView;
    t3 = notification.read;
    if ($[17] !== getIcon) {
      t4 = getIcon();
      $[17] = getIcon;
      $[18] = t4;
    } else {
      t4 = $[18];
    }
    if ($[19] !== getMessage) {
      t5 = getMessage();
      $[19] = getMessage;
      $[20] = t5;
    } else {
      t5 = $[20];
    }
    t6 = getDescription();
    $[3] = cancelSharing;
    $[4] = mutate;
    $[5] = notificationItem;
    $[6] = sharingStatus;
    $[7] = t;
    $[8] = user;
    $[9] = T0;
    $[10] = handleCancel;
    $[11] = handleNotificationClick;
    $[12] = notification;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    T0 = $[9];
    handleCancel = $[10];
    handleNotificationClick = $[11];
    notification = $[12];
    t3 = $[13];
    t4 = $[14];
    t5 = $[15];
    t6 = $[16];
  }
  const t7 = notification.data.status === SharingStatusEnum.Running;
  let t8;
  if ($[21] !== T0 || $[22] !== handleCancel || $[23] !== handleNotificationClick || $[24] !== isCancelling || $[25] !== t3 || $[26] !== t4 || $[27] !== t5 || $[28] !== t6 || $[29] !== t7) {
    t8 = <T0 isRead={t3} icon={t4} message={t5} description={t6} showCancelButton={t7} isCancelling={isCancelling} onClick={handleNotificationClick} onCancel={handleCancel} />;
    $[21] = T0;
    $[22] = handleCancel;
    $[23] = handleNotificationClick;
    $[24] = isCancelling;
    $[25] = t3;
    $[26] = t4;
    $[27] = t5;
    $[28] = t6;
    $[29] = t7;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  return t8;
};
export default SharingNotificationItem;
function _temp(data) {
  if (!data) {
    return;
  }
  return {
    ...data,
    status: SharingStatusEnum.Failed,
    failReason: SharingFailReasonEnum.CancelledByUser
  };
}